// extracted by mini-css-extract-plugin
module.exports = {"root":"TextEditor_root__2bR0t","editor":"TextEditor_editor__3_xcJ","requiredLabel":"TextEditor_requiredLabel__D8pLU"};